module.exports = __webpack_public_path__ + "img/loading.1b0625bd.png";